import { createActionsHook } from 'src/lib/sweetState';

import { InAppNotificationsStore } from './Store';

export const useNotificationsCenterActions = createActionsHook(InAppNotificationsStore);
